// Generated by purs version 0.15.15
import * as Ouroboros_Models_Ui_InviteAcceptBodyPhase from "../Ouroboros.Models.Ui.InviteAcceptBodyPhase/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_InviteAccept from "../Ouroboros.Programs.Controllers.InviteAccept/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var readState = function (v) {
    return v;
};
var bodyPhaseFromToken = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return Ouroboros_Models_Ui_InviteAcceptBodyPhase.inviteAcceptBodyPhaseNamespace.missingToken;
})(function (v) {
    return Ouroboros_Models_Ui_InviteAcceptBodyPhase.inviteAcceptBodyPhaseNamespace.ready;
});
var buildInviteAcceptViewProps = function (input) {
    return {
        password: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.password)),
        confirmPassword: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.confirmPassword)),
        firstName: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.firstName)),
        lastName: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.lastName)),
        onPasswordChange: function (next) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.password))(next);
        },
        onConfirmPasswordChange: function (next) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.confirmPassword))(next);
        },
        onFirstNameChange: function (next) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.firstName))(next);
        },
        onLastNameChange: function (next) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.lastName))(next);
        },
        onSubmit: function (v) {
            return Ouroboros_Programs_Controllers_InviteAccept.runInviteAcceptAction(input.kernel.controller.submit);
        },
        bodyPhase: bodyPhaseFromToken(input.token)
    };
};
export {
    buildInviteAcceptViewProps
};
//# sourceMappingURL=index.js.map
